'use client'

import { MailBoxContext } from '../mail-box-provider'
import { SignalRNotificationKey } from '../../signal-r-provider/SignalRNotificationKey'
import { SignalRMessageProps } from '../../signal-r-provider/signal-r-provider'
import { useContext, useEffect } from 'react'

/**
 * @description - This hook can be used to listen to one mail box in the mail provider.
 *
 * @param mailBoxKey - The mailboxe you wish to collect mail for
 * @param callback - The function that gets called with each new notification
 */
export const useMailListener = (
    mailBoxKey: SignalRNotificationKey,
    callback: (notification: SignalRMessageProps) => void,
) => {
    const { mailBoxes } = useContext(MailBoxContext)

    useEffect(() => {
        if (mailBoxKey in mailBoxes && !!mailBoxes[mailBoxKey]?.length) {
            mailBoxes[mailBoxKey].forEach(callback)
        }
    }, [mailBoxes[mailBoxKey]])
}
